import MachineImg1 from "../../../../assets/images/IMG_8495.jpg";
import MachineImg2 from "../../../../assets/png/ENGINEERING.jpg";
import MachineImg3 from "../../../../assets/images/ElectricDual_One(1).jpg";
import MachineImg4 from "../../../../assets/images/nz-img-4.png";
import { useNavigate } from "react-router";
import { NZRouterPaths } from "../../../../router/router";
import StarIcon from "../../../../assets/svg/star-fill.svg";
const NZTutaraOption = () => {
  let navigate = useNavigate();
  return (
    <div className="pt-[86px] pb-[65px] bg-[#f7f7f7]">
      <div className="md:max-w-[80%] max-w-full mx-auto py-[30px]">
        <div className="custom-container px-[30px] text-center">
          <h2 className="font-Teko 2xl:text-[62px] lg:text-[66px] md:text-[55px] text-[55px] font-semibold	lg:mb-[25px] sm:mb-[20px] mb-[10px] text-[#333] leading-[1em]  kuunari-bold">
            Built for the Industries That Keep New Zealand Moving
          </h2>
          <p className="font-lato  text-[16px] montserrat-medium  text-[#333] leading-[1.8em] lg:mb-[25px] sm:mb-[20px] mb-[10px]">
            Tuatara side-by-side ATV vehicles work across some of the toughest industries in New Zealand. From farming and horticulture to civil construction, mining and council ground works, these machines are relied on where downtime isn’t an option.
          </p>
          <p className="font-lato  text-[16px] montserrat-medium text-[#333] leading-[1.8em] lg:mb-[25px] sm:mb-[20px] mb-[10px]">
            You’ll find Tuataras operating on large rural properties, infrastructure projects, managed facilities and industrial sites where access, load capacity and consistency matter. Operators choose Tuatara because it delivers practical capability in environments that demand more than a recreational ATV.
          </p>
          <p className="font-lato  text-[16px] montserrat-medium text-[#333] leading-[1.8em] lg:mb-[25px] sm:mb-[20px] mb-[10px]">
            With electric and petrol models available, the Tuatara range adapts to different sites, regulations and operating requirements, without compromising on output. </p>
          <p className="flex flex-wrap justify-center mt-4 gap-4 sm:grid sm:grid-cols-2 lg:flex lg:flex-row">
            {["Powerful", "Go Anywhere", "Versatile", "Low Maintenance"].map(
              (text, index) => (
                <span
                  key={index}
                  className="flex items-center gap-2 text-[16px] leading-[24px]"
                >
                  <img src={StarIcon} alt="" className="w-4 h-4" />
                  {text}
                </span>
              )
            )}
          </p>
        </div>
      </div>
      <div className="custom-container py-[30px]">
        {/* <h3 className="font-Teko text-center text-[35px] text-[#333] leading-[1em] mb-[30px] kuunari-bold">
          2025 Models
        </h3> */}
        <h2 className="text-center font-Teko 2xl:text-[62px] lg:text-[66px] md:text-[55px] text-[40px] font-semibold lg:mb-[20px] mb-[10px] text-[#333] leading-[1em] kuunari-bold">
          Explore the Tuatara ATV & Side-by-Side Range
        </h2>
        <p className="text-center font-lato text-[16px] montserrat-medium text-[#333] leading-[1.8em] lg:mb-[40px] sm:mb-[20px] mb-[20px] max-w-[900px] mx-auto">
          The Tuatara range covers petrol and electric side-by-side ATV vehicles, giving you options based on how and where you need to run them. Compare the models below and choose the ATV that fits your workload.
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-3">
          <div className="col-span-1 flex flex-col h-full justify-between items-center">
            <div className="flex flex-col w-full justify-start items-center">
              <div className="w-full h-[200px] xl:h-[262px] flex items-center justify-center mb-[15px]">
                <img
                  src={MachineImg1}
                  alt="Tuatara Petrol Side-by-Side ATV"
                  className="w-full max-h-full object-contain"
                />
              </div>

              <h3 className="font-Teko text-center text-[30px] text-[#333] leading-[1em] min-h-[60px] flex items-center justify-center">
                Petrol Side-by-Side ATV
              </h3>

              <p className="text-center text-[#333] text-[16px] leading-[25px] montserrat-medium mt-2">
                Reliable petrol power for long days and heavy loads. Strong towing, quick refuelling and consistent
                output when the work doesn't stop.
              </p>
            </div>
            <div className="mb-[30px] mt-[20px] w-full flex justify-center">
              <div
                className="bg-[#af8600] montserrat-medium text-center text-[16px] text-white uppercase leading-[40px] px-[16px] py-[5px] cursor-pointer"
                onClick={() => {
                  navigate(NZRouterPaths.Petrol);
                }}
              >
                EXPLORE THE PETROL MODEL
              </div>
            </div>
          </div>
          <div className="col-span-1 flex flex-col h-full justify-between items-center">
            <div className="flex flex-col w-full justify-start items-center">
              <div className="w-full h-[200px] xl:h-[262px] flex items-center justify-center mb-[15px]">
                <img
                  src={MachineImg2}
                  alt="Electric Model Side-by-Side ATV"
                  className="w-full max-h-full object-contain"
                />
              </div>
              <h3 className="font-Teko text-center text-[30px] text-[#333] leading-[1em] min-h-[60px] flex items-center justify-center">
                Electric Side-by-Side ATV
              </h3>
              <p className="text-center text-[#333] text-[16px] leading-[25px] montserrat-medium mt-2">
                Instant torque with lower running costs and reduced noise. A practical option for regulated sites and
                operations, cutting fuel use.
              </p>
            </div>
            <div className="mb-[30px] mt-[20px] w-full flex justify-center">
              <div
                className="bg-[#af8600] montserrat-medium text-center text-[16px] text-white uppercase leading-[40px] px-[16px] py-[5px] cursor-pointer"
                onClick={() => {
                  navigate(NZRouterPaths.ElectricAccessories);
                }}
              >
                VIEW THE ELECTRIC MODEL
              </div>
            </div>
          </div>
          <div className="col-span-1 flex flex-col h-full justify-between items-center">
            <div className="flex flex-col w-full justify-start items-center">
              <div className="w-full h-[200px] xl:h-[262px] flex items-center justify-center mb-[15px]">
                <img
                  src={MachineImg3}
                  alt="Dual Motor / Dual Cabin (Electric)"
                  className="w-full max-h-full object-contain"
                />
              </div>
              <h3 className="font-Teko text-center text-[30px] text-[#333] leading-[1em] min-h-[60px] flex items-center justify-center">
                Dual Motor / Dual Cabin (Electric)
              </h3>
              <p className="text-center text-[#333] text-[16px] leading-[25px] montserrat-medium mt-2">
                More torque. More seats. Built for heavier workloads and larger crews without stepping up to a bigger machine.
              </p>
            </div>
            <div className="mb-[30px] mt-[20px] w-full flex justify-center">
              <div
                className="bg-[#af8600] montserrat-medium text-center text-[16px] text-white uppercase leading-[40px] px-[16px] py-[5px] cursor-pointer"
                onClick={() => {
                  navigate(NZRouterPaths.ElectricDualMotor);
                }}
              >
                SEE DUAL MOTOR OPTIONS
              </div>
            </div>
          </div>
          <div className="col-span-1 flex flex-col h-full justify-between items-center">
            <div className="flex flex-col w-full justify-start items-center">
              <div className="w-full h-[200px] xl:h-[262px] flex items-center justify-center mb-[15px]">
                <img
                  src={MachineImg4}
                  alt="Orchardised (Electric)"
                  className="w-full max-h-full object-contain"
                />
              </div>
              <h3 className="font-Teko text-center text-[30px] text-[#333] leading-[1em] min-h-[60px] flex items-center justify-center">
                Orchardised Electric Model
              </h3>
              <p className="text-center text-[#333] text-[16px] leading-[25px] montserrat-medium mt-2">
                Set up for low-clearance work and tight rows. Purpose-built for orchards and specialist agricultural operations.
              </p>
            </div>
            <div className="mb-[30px] mt-[20px] w-full flex justify-center">
              <div
                className="bg-[#af8600] montserrat-medium text-center text-[16px] text-white uppercase leading-[40px] px-[16px] py-[5px] cursor-pointer"
                onClick={() => {
                  navigate(NZRouterPaths.Orchardised);
                }}
              >
                EXPLORE THE ORCHARD MODEL
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NZTutaraOption;
